import DynamicList from './src/dynamiclist.vue';

DynamicList.install = function (Vue) {
    Vue.component(DynamicList.name, DynamicList);
};

export default DynamicList;